const translations = {
  en: {
    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.assets": "Assets",
    "nav.credits": "Credits",
    "nav.opportunities": "Opportunities",
    "nav.reports": "Reports",
    "nav.settings": "Settings",
    "nav.admin": "Admin Panel",
    "nav.logout": "Sign Out",
    "nav.displayCurrency": "Display Currency",
    "nav.language": "Language",
    "nav.lightMode": "Light Mode",
    "nav.darkMode": "Dark Mode",
    "nav.myDeals": "My Deals",
    "nav.defi": "DeFi",
    "nav.stocks": "Stocks",
    "nav.web3": "Web3 Secondaries",
    "nav.commodities": "Commodities",

    // Landing
    "landing.tagline": "Your Wealth, Engineered",
    "landing.badge": "Track, Discover, Build",
    "landing.hero1": "The Wealth Advisor",
    "landing.hero2": "You Can Actually Afford",
    "landing.sub1": "One command center for everything you own — and everything you should own next. From stocks to crypto, real estate to watches, DeFi yields to Web3 secondaries.",
    "landing.sub2": "AI-powered trend analysis, curated investment opportunities, and portfolio intelligence that private bankers charge 1% to deliver. Except here, you're in control.",
    "landing.cta": "Build Your Wealth For Free",
    "landing.nocredit": "No private information needed.",
    "landing.stat1": "Any Asset",
    "landing.stat1sub": "Stocks to Supercars",
    "landing.stat2": "AI-Powered",
    "landing.stat2sub": "Risk & Recommendations",
    "landing.stat3": "Multi-Currency",
    "landing.stat3sub": "USD, EUR, BTC",
    "landing.stat4": "Curated Deals",
    "landing.stat4sub": "DeFi, Web3 & More",
    "landing.trackManage": "Track & Manage",
    "landing.discoverBuild": "Discover & Build",
    "landing.feat.everyAsset": "Every Asset Type",
    "landing.feat.everyAssetDesc": "Stocks via ISIN, crypto, commodities, real estate, watches, art, private equity. If it has value, it belongs here.",
    "landing.feat.charts": "Performance Charts",
    "landing.feat.chartsDesc": "Historical performance with 30D, 12M, and all-time views. Track your wealth trajectory over time.",
    "landing.feat.credit": "Credit Optimization",
    "landing.feat.creditDesc": "LTV calculations, collateral mapping, payment schedules. Know exactly how much leverage you can safely use.",
    "landing.feat.reports": "Auto PDF Reports",
    "landing.feat.reportsDesc": "Professional portfolio reports generated monthly. Download anytime. Look like you have a family office.",
    "landing.feat.advisor": "AI Wealth Advisor",
    "landing.feat.advisorDesc": "Portfolio analysis, risk scoring, and actionable recommendations powered by GPT. Like a private banker that works for you.",
    "landing.feat.macro": "Macro-Driven Picks",
    "landing.feat.macroDesc": "AI scans global trends to surface stock and ETF ideas by region — the kind of analysis Tier-1 advisors keep behind closed doors.",
    "landing.feat.defi": "DeFi & Web3 Deals",
    "landing.feat.defiDesc": "Live DeFi yields, OTC Web3 secondaries from Acquire.fi, and exclusive curated opportunities. New alpha, delivered.",
    "landing.feat.risk": "Risk Intelligence",
    "landing.feat.riskDesc": "Every asset scored. Portfolio-wide risk assessment. Know where you're exposed before the market tells you.",
    "landing.bottomTitle": "Stop Managing Wealth in Spreadsheets",
    "landing.bottomSub": "Your net worth deserves better than a Google Sheet. Cableway Finance is the command center that wealth managers charge six figures to provide — except you're in control.",
    "landing.bottomCta": "Get Started Now",
    "landing.tryDemo": "See a Demo",
    "landing.footer": "Cableway Finance. Taking your wealth to the summit.",
    "landing.signin": "Sign In",

    // Dashboard
    "dash.title": "Dashboard",
    "dash.subtitle": "Your portfolio at a glance",
    "dash.totalValue": "Total Portfolio Value",
    "dash.gainLoss": "Gain / Loss",
    "dash.netWorth": "Net Worth",
    "dash.riskScore": "Portfolio Risk",
    "dash.historicalPerf": "Historical Performance",
    "dash.breakdown": "Asset Breakdown",
    "dash.creditCapacity": "Credit Capacity",
    "dash.performance": "Performance",
    "dash.recentAssets": "Recent Assets",
    "dash.recentCredits": "Recent Credits",
    "dash.noAssets": "No assets yet. Add your first asset to see breakdown.",
    "dash.noAssetsShort": "No assets yet. Start building your portfolio!",
    "dash.noCredits": "No credits yet",
    "dash.advisor": "AI Wealth Advisor",
    "dash.advisorSub": "Portfolio insights & recommendations",
    "dash.refreshPrices": "Refresh Prices",
    "dash.updating": "Updating...",
    "dash.allTime": "all time",
    "dash.afterCredits": "After {count} credits",
    "dash.notEnoughData": "Not enough data yet",
    "dash.notEnoughDataSub": "Historical data is captured daily. Check back tomorrow for your first chart.",
    "dash.portfolioValue": "Portfolio Value",
    "dash.askPortfolio": "Ask about your portfolio...",
    "dash.analyzing": "Analyzing...",
    "dash.annReturn": "Ann. Return",
    "dash.creditPayments": "Credit Payments/mo",
    "dash.assetsCredits": "Assets / Credits",
    "dash.available": "Available",
    "dash.totalCapacity": "Total Capacity",
    "dash.used": "Used",
    "dash.pl": "P/L",

    // Assets
    "assets.title": "Assets",
    "assets.subtitle": "Manage your investment portfolio",
    "assets.addAsset": "Add Asset",
    "assets.addNew": "Add New Asset",
    "assets.editAsset": "Edit Asset",
    "assets.enterDetails": "Enter the details of your asset",
    "assets.updateDetails": "Update asset details",
    "assets.searchAssets": "Search assets...",
    "assets.allTypes": "All Types",
    "assets.noAssets": "No assets found",
    "assets.addFirst": "Add Your First Asset",
    "assets.type": "Type",
    "assets.quantity": "Quantity",
    "assets.purchasePrice": "Purchase Price",
    "assets.currentPrice": "Current Price",
    "assets.acquisitionDate": "Acquisition Date",
    "assets.currency": "Currency",
    "assets.ltv": "LTV (Loan to Value) %",
    "assets.riskScore": "Risk Score",
    "assets.riskNotes": "Risk Notes",
    "assets.notes": "Notes",
    "assets.category": "Category",
    "assets.assetName": "Asset Name",
    "assets.searchCrypto": "Search Cryptocurrency",
    "assets.searchStock": "Search Stock (or enter ISIN below)",
    "assets.searchCommodity": "Search Commodity",
    "assets.orEnterIsin": "Or Enter ISIN",
    "assets.aiRiskAssessment": "AI Risk Assessment",
    "assets.recommendedRisk": "Recommended Risk Score",
    "assets.justification": "Justification",
    "assets.recommendations": "Recommendations",
    "assets.applyRisk": "Apply Risk Score",
    "assets.saveChanges": "Save Changes",
    "assets.asset": "Asset",
    "assets.price": "Price",
    "assets.value": "Value",
    "assets.held": "Held",
    "assets.risk": "Risk",
    "assets.actions": "Actions",
    "assets.cash": "Cash",
    "assets.accountName": "Account Name",
    "assets.cashNamePlaceholder": "e.g. Chase Checking, Livret A, Emergency Fund...",
    "assets.cashSubcategory": "Account Type",
    "assets.selectAccountType": "Select account type",
    "assets.cashChecking": "Checking",
    "assets.cashSavings": "Savings",
    "assets.cashMoneyMarket": "Money Market",
    "assets.cashCertificate": "Certificate of Deposit",
    "assets.cashOther": "Other",
    "assets.cashBalance": "Balance",
    "assets.addedSuccess": "Asset added successfully",
    "assets.addFailed": "Failed to add asset",
    "assets.welcomeTitle": "Welcome to Your Portfolio",
    "assets.welcomeSub": "Get started by connecting your bank, using AI-guided setup, or adding assets manually.",
    "assets.onboardBank": "Connect Your Bank",
    "assets.onboardBankDesc": "Automatically import your accounts via Plaid — stocks, cash, and liabilities.",
    "assets.onboardAI": "AI-Guided Setup",
    "assets.onboardAIDesc": "Add an asset and let our AI assess its risk profile and fit for your portfolio.",
    "assets.onboardAIBtn": "Start with AI",
    "assets.onboardManual": "Add Manually",
    "assets.onboardManualDesc": "Enter your stocks, crypto, real estate, or any asset type directly.",
    "assets.onboardDemoLocked": "Demo Mode",
    "assets.onboardBankDescPro": "Automatically import your accounts via Secure PSD2 Open Banking — stocks, cash, and liabilities.",
    "assets.switchToPro": "Switch to PRO",
    "assets.proRequestSent": "Your PRO upgrade request has been sent!",
    "assets.proRequestFailed": "Failed to send request",
    "assets.aiAssistantTitle": "AI Portfolio Assistant",
    "assets.aiAssistantPlaceholder": "Ask about portfolio building...",
    "assets.aiAssistantHint": "Ask me anything about building your portfolio",
    "plaid.connectBank": "Connect Bank",
    "plaid.connectedBanks": "Connected Banks",

    // Credits
    "credits.title": "Credits",
    "credits.subtitle": "Manage and track your credits",
    "credits.addCredit": "Add Credit",
    "credits.creditType": "Credit Type",
    "credits.allTypes": "All Types",
    "credits.typeMortgage": "Mortgage",
    "credits.typeAutoLoan": "Auto Loan",
    "credits.typeStudentLoan": "Student Loan",
    "credits.typePersonalLoan": "Personal Loan",
    "credits.typeBusinessLoan": "Business Loan",
    "credits.typeCreditCard": "Credit Card",
    "credits.typeLombard": "Lombard / Margin",
    "credits.typeOther": "Other",
    "credits.addNew": "Add New Credit",
    "credits.editCredit": "Edit Credit",
    "credits.enterDetails": "Enter the details of your credit/loan",
    "credits.updateDetails": "Update credit details",
    "credits.creditName": "Credit Name",
    "credits.lender": "Lender",
    "credits.principal": "Principal Amount",
    "credits.outstanding": "Outstanding Amount",
    "credits.interestRate": "Interest Rate (%)",
    "credits.monthlyPayment": "Monthly Payment",
    "credits.startDate": "Start Date",
    "credits.termMonths": "Term (months)",
    "credits.calculatedEnd": "Calculated End Date",
    "credits.setStartTerm": "Set start date and term",
    "credits.paymentDate": "Payment Date in Month",
    "credits.paymentBeginning": "Beginning of the month (1st-5th)",
    "credits.paymentMid": "Mid-month (13th-17th)",
    "credits.paymentEnd": "End of the month (25th-30th)",
    "credits.collateral": "Collateral Asset",
    "credits.noCollateral": "None (no collateral)",
    "credits.other": "Other",
    "credits.noCredits": "No credits yet",
    "credits.addFirst": "Add Your First Credit",
    "credits.yourCredits": "Your Credits",
    "credits.totalPaid": "Total Paid",
    "credits.paidLastMonth": "Paid Last Month",
    "credits.totalRemaining": "Total Remaining",
    "credits.nextMonth": "Next Month",
    "credits.creditCapacity": "Credit Capacity",
    "credits.utilization": "Utilization",
    "credits.totalCapacity": "Total Capacity",
    "credits.available": "Available",
    "credits.totalOutstanding": "Total Outstanding",
    "credits.monthlyPayments": "Monthly Payments",
    "credits.totalPerMonth": "Total per month",
    "credits.activeCredits": "active credit",
    "credits.activeCreditsPlural": "active credits",
    "credits.credit": "Credit",
    "credits.rate": "Rate",
    "credits.monthly": "Monthly",
    "credits.payment": "Payment",
    "credits.saveChanges": "Save Changes",
    "credits.deleteCredit": "Delete Credit",
    "credits.notes": "Notes",
    "credits.tipTotalPaid": "Cumulative amount you have repaid across all credits since their start dates, based on monthly payments and elapsed months.",
    "credits.tipPaidLastMonth": "Sum of monthly payments across all active credits for the most recent calendar month.",
    "credits.tipTotalRemaining": "Total outstanding balance still owed across all credits (principal not yet repaid).",
    "credits.tipNextMonth": "Projected total payment due next month across all active credits.",
    "credits.tipCreditCapacity": "Maximum borrowing power based on the LTV (Loan-to-Value) ratios of your assets. Available = Total Capacity minus Used Credit.",
    "credits.tipUtilization": "Percentage of your total borrowing capacity currently in use. Lower is healthier.",
    "credits.tipTotalOutstanding": "Sum of outstanding balances across all your credit positions.",
    "credits.tipMonthlyPayments": "Sum of all monthly payment obligations across your active credits.",

    // Opportunities
    "opps.title": "Opportunities",
    "opps.subtitle": "Discover investment opportunities across channels",
    "opps.refresh": "Refresh",
    "opps.addManual": "Add Opportunity",
    "opps.addOpportunity": "Add Opportunity",
    "opps.addCustom": "Add a custom investment opportunity",
    "opps.saveOpportunity": "Add Opportunity",
    "opps.myDeals": "My Deals",
    "opps.defi": "DeFi",
    "opps.commodities": "Commodities",
    "opps.web3": "Web3 Secondaries",
    "opps.stocks": "Stocks",
    "opps.others": "Others",
    "opps.recommended": "Cableway Recommended",
    "opps.oppsFound": "Opportunities Found",
    "opps.avgApy": "Average APY",
    "opps.totalTvl": "Total TVL Tracked",
    "opps.availableOpps": "Available Opportunities",
    "opps.noOpps": "No opportunities found matching your filters",
    "opps.refreshOpps": "Refresh Opportunities",
    "opps.visitVault": "Visit Vault",
    "opps.refreshData": "Refresh Data",
    "opps.scraping": "Scraping...",
    "opps.lastRefresh": "Last refresh",
    "opps.totalListings": "Total Listings",
    "opps.selling": "Selling",
    "opps.buying": "Buying",
    "opps.viewDeal": "View Deal",
    "opps.contact": "Contact",
    "opps.noAltData": "No alternatives data yet",
    "opps.noAltResults": "No results match your filters",
    "opps.clickRefresh": "Click \"Refresh Data\" to scrape the latest OTC deals from Acquire.Fi",
    "opps.tryFilters": "Try adjusting your filters",
    "opps.refreshTrends": "Refresh Trends",
    "opps.analyzing": "Analyzing...",
    "opps.allRegions": "All Regions",
    "opps.noStockTrends": "No stock trends data yet",
    "opps.clickRefreshTrends": "Click \"Refresh Trends\" to get AI-powered stock and ETF recommendations",
    "opps.eurUsdChart": "EUR/USD Exchange Rate (1 Year)",
    "opps.portfolioFit": "Portfolio Fit",
    "opps.name": "Name",
    "opps.category": "Category",
    "opps.description": "Description",
    "opps.type": "Type (free text)",
    "opps.expectedReturn": "Expected Return",
    "opps.price": "Price",
    "opps.ticketMin": "Ticket Min",
    "opps.url": "URL (optional)",
    "opps.riskScore": "Risk Score",
    "opps.protocol": "Protocol",
    "opps.chain": "Chain",
    "opps.apy": "APY (%)",
    "opps.tvl": "TVL (USD)",
    "opps.token": "Token",
    "opps.imageUrl": "Image URL",
    "opps.notes": "Notes",
    "opps.search": "Search",
    "opps.categoryFilter": "Category",
    "opps.typeFilter": "Type",
    "opps.minTicket": "Min Ticket",
    "opps.anyAmount": "Any Amount",
    "opps.minTvl": "Min TVL",
    "opps.tokenFilter": "Token Filter",
    "opps.minApy": "Min APY (%)",
    "opps.maxApy": "Max APY (%)",
    "opps.riskLevel": "Risk Level",
    "opps.allRisks": "All Risks",
    "opps.lowRisk": "Low Risk",
    "opps.mediumRisk": "Medium Risk",
    "opps.highRisk": "High Risk",
    "opps.sortBy": "Sort By",
    "opps.highestApy": "Highest APY",
    "opps.highestTvl": "Highest TVL",
    "opps.lowestRisk": "Lowest Risk",
    "opps.apply": "Apply",
    "opps.manualOpps": "Your Manual Opportunities",
    "opps.noManualOpps": "No manual opportunities yet",

    // Reports
    "reports.title": "Reports",
    "reports.sub": "Monthly portfolio reports are generated automatically on the 1st. You can also generate one manually (once/day).",
    "reports.generate": "Generate Report",
    "reports.generating": "Generating...",
    "reports.history": "Report History",
    "reports.noReports": "No reports yet",
    "reports.noReportsSub": "Click \"Generate Report\" to create your first portfolio report.",
    "reports.date": "Date",
    "reports.month": "Month",
    "reports.type": "Type",
    "reports.portfolioValue": "Portfolio Value",
    "reports.pl": "P/L",
    "reports.assets": "Assets",
    "reports.actions": "Actions",

    // Admin
    "admin.title": "Admin Panel",
    "admin.subtitle": "Manage users and push opportunities",
    "admin.users": "Users",
    "admin.pushedOpps": "Pushed Opportunities",
    "admin.accessDenied": "Access Denied",
    "admin.noPrivileges": "You don't have admin privileges.",
    "admin.searchUsers": "Search users...",
    "admin.user": "User",
    "admin.status": "Status",
    "admin.portfolio": "Portfolio",
    "admin.assetsCount": "Assets",
    "admin.lastLogin": "Last Login",
    "admin.actions": "Actions",
    "admin.backToList": "Back to list",
    "admin.removeAdmin": "Remove Admin",
    "admin.makeAdmin": "Make Admin",
    "admin.generateReport": "Generate Report",
    "admin.confirmAdminChange": "Confirm Admin Status Change",
    "admin.removeAdminMsg": "Remove admin privileges from {name}?",
    "admin.grantAdminMsg": "Grant admin privileges to {name} ({email})?",
    "admin.newOpportunity": "New Opportunity",
    "admin.createOpp": "Create Opportunity",
    "admin.editOpp": "Edit Opportunity",
    "admin.oppPushed": "This will be pushed as a \"Cableway Recommended\" opportunity",
    "admin.deleteOpp": "Delete Opportunity",
    "admin.deleteOppMsg": "Delete \"{name}\"? This will remove it from all users.",
    "admin.target": "Target",
    "admin.allUsers": "All Users",
    "admin.selectedUsers": "Selected Users",
    "admin.published": "Published",
    "admin.expires": "Expires",
    "admin.noPublished": "No published opportunities yet",
    "admin.pushFirst": "Push your first recommendation to all users",
    "admin.publicationDate": "Publication Date",
    "admin.expirationDate": "Expiration Date",
    "admin.noUsers": "No users found",
    "admin.portfolioValue": "Portfolio Value",

    // Settings
    "settings.title": "Settings",
    "settings.subtitle": "Manage your account preferences",
    "settings.profile": "Profile",
    "settings.profileDesc": "Your account information",
    "settings.appearance": "Appearance",
    "settings.appearanceDesc": "Customize the look and feel",
    "settings.theme": "Theme",
    "settings.themeDesc": "Switch between light and dark mode",
    "settings.light": "Light",
    "settings.dark": "Dark",
    "settings.displayCurrency": "Display Currency",
    "settings.displayCurrencyDesc": "Choose how to display monetary values",
    "settings.language": "Language",
    "settings.languageDesc": "Choose your preferred display language",
    "settings.languageConvert": "All text will be displayed in this language",
    "settings.currencyLabel": "Currency",
    "settings.currencyConvert": "All values will be converted to this currency",
    "settings.security": "Security",
    "settings.securityDesc": "Manage your account security",
    "settings.investPrefs": "Investment Preferences",
    "settings.investPrefsDesc": "Configure your investment profile and opportunity visibility",
    "settings.riskTolerance": "Risk Tolerance",
    "settings.riskToleranceDesc": "This influences Portfolio Fit scoring for stock recommendations",
    "settings.risk_conservative": "Conservative",
    "settings.risk_moderate": "Moderate",
    "settings.risk_aggressive": "Aggressive",
    "settings.preferredRegions": "Preferred Regions",
    "settings.preferredRegionsDesc": "Select which stock regions interest you most",
    "settings.visibleChannels": "Visible Opportunity Channels",
    "settings.visibleChannelsDesc": "Choose which opportunity tabs to display",
    "settings.googleConnected": "Connected with Google",
    "settings.googleAuth": "Your account is securely authenticated via Google",
    "settings.signOut": "Sign Out",
    "settings.signOutDesc": "Sign out of your account on this device",
    "settings.version": "Cableway Finance v1.0.0",
    "settings.builtFor": "Taking your wealth to the summit",

    // Common
    "common.loading": "Loading...",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.add": "Add",
    "common.search": "Search",
    "common.name": "Name",
    "common.type": "Type",
    "common.value": "Value",
    "common.date": "Date",
    "common.actions": "Actions",
    "common.previous": "Previous",
    "common.next": "Next",
    "common.page": "Page",
    "common.of": "of",
    "common.results": "results",
    "common.never": "Never",
    "common.publish": "Publish",
    "common.update": "Update",

    // Budget
    "nav.budget": "Budget",
    "budget.title": "Budget",
    "budget.subtitle": "Track your income and expenses",
    "budget.refresh": "Refresh",
    "budget.monthlyIncome": "Monthly Income",
    "budget.monthlyIncomeTooltip": "Total recurring income converted to monthly equivalent",
    "budget.monthlyExpenses": "Monthly Expenses",
    "budget.monthlyExpensesTooltip": "User-defined recurring expenses converted to monthly",
    "budget.creditPayments": "Credit Payments",
    "budget.creditPaymentsTooltip": "Monthly payments from your credits/liabilities",
    "budget.netCashFlow": "Net Cash Flow",
    "budget.netCashFlowTooltip": "Income minus all expenses and credit payments",
    "budget.perMonth": "/month",
    "budget.sources": "sources",
    "budget.items": "items",
    "budget.credits": "credits",
    "budget.budgetHealth": "Budget Health",
    "budget.budgetHealthTooltip": "Based on savings rate: 30%+ = Excellent, 20%+ = Good, 10%+ = Fair, 0%+ = At Risk, Negative = Critical",
    "budget.savingsRate": "Savings Rate",
    "budget.projection6m": "6-Month Projection",
    "budget.projection12m": "12-Month Projection",
    "budget.projectionDesc": "Based on current cash flow",
    "budget.cashReserves": "Cash Reserves",
    "budget.runway": "Runway",
    "budget.months": "months",
    "budget.incomeSources": "Income Sources",
    "budget.incomeSourcesDesc": "Recurring income streams",
    "budget.expenses": "Expenses",
    "budget.expensesDesc": "Recurring outflows",
    "budget.addIncome": "Add Income",
    "budget.addExpense": "Add Expense",
    "budget.editIncome": "Edit Income",
    "budget.editExpense": "Edit Expense",
    "budget.source": "Source",
    "budget.expense": "Expense",
    "budget.category": "Category",
    "budget.monthly": "Monthly",
    "budget.actions": "Actions",
    "budget.edit": "Edit",
    "budget.delete": "Delete",
    "budget.noIncome": "No income sources yet",
    "budget.noExpenses": "No expenses yet",
    "budget.addFirst": "Add your first income source",
    "budget.addFirstExpense": "Add your first expense",
    "budget.creditPaymentsBreakdown": "Credit Payments Breakdown",
    "budget.creditPaymentsBreakdownDesc": "Monthly payments from your liabilities",
    "budget.creditName": "Credit",
    "budget.type": "Type",
    "budget.monthlyPayment": "Monthly Payment",
    "budget.incomeFormDesc": "Enter details about this income source",
    "budget.expenseFormDesc": "Enter details about this expense",
    "budget.name": "Name",
    "budget.frequency": "Frequency",
    "budget.amount": "Amount",
    "budget.currency": "Currency",
    "budget.startDate": "Start Date",
    "budget.optional": "optional",
    "budget.cancel": "Cancel",
    "budget.add": "Add",
    "budget.update": "Update",
    "budget.incomeAdded": "Income added",
    "budget.incomeUpdated": "Income updated",
    "budget.expenseAdded": "Expense added",
    "budget.expenseUpdated": "Expense updated",
    "budget.saveFailed": "Failed to save",
    "budget.deleted": "Deleted successfully",
    "budget.deleteFailed": "Failed to delete",
    "budget.deleteIncome": "Delete Income",
    "budget.deleteExpense": "Delete Expense",
    "budget.fetchError": "Failed to load budget data",
    "budget.predictionsChart": "12-Month Forecast",
    "budget.predictionsChartDesc": "Projected income vs. spending",
    "budget.monthlyAvg": "Monthly Avg",
    "budget.recurring": "Recurring",
    "budget.income": "Income",
    "budget.totalExpenses": "Total Expenses",
    "budget.noDataForChart": "Add income or expenses to see projections",
    "budget.passiveIncome": "Passive Income",
    "budget.passiveIncomeDesc": "Income that requires minimal effort",
    "budget.yearly": "Yearly",
    "budget.passiveRatio": "Passive ratio",
    "budget.ofTotalIncome": "of total income",
    "budget.noPassiveIncome": "No passive income yet",
    "budget.markAsPassive": "Mark income sources as passive when adding",
    "budget.passiveIncomeLabel": "This is passive income",
    "budget.passiveIncomeHint": "e.g., dividends, rental, interest - income that requires minimal effort",
    "budget.passive": "Passive",
  },

  fr: {
    // Navigation
    "nav.dashboard": "Tableau de bord",
    "nav.assets": "Actifs",
    "nav.credits": "Crédits",
    "nav.opportunities": "Opportunités",
    "nav.reports": "Rapports",
    "nav.settings": "Paramètres",
    "nav.admin": "Administration",
    "nav.logout": "Déconnexion",
    "nav.displayCurrency": "Devise d'affichage",
    "nav.language": "Langue",
    "nav.lightMode": "Mode clair",
    "nav.darkMode": "Mode sombre",
    "nav.myDeals": "Mes Deals",
    "nav.defi": "DeFi",
    "nav.stocks": "Actions",
    "nav.web3": "Secondaires Web3",
    "nav.commodities": "Matières Premières",
    "landing.tagline": "Votre Patrimoine, Optimisé",
    "landing.badge": "Suivre, Découvrir, Construire",
    "landing.hero1": "Le Conseiller Financier",
    "landing.hero2": "Que Vous Pouvez Vous Offrir",
    "landing.sub1": "Un centre de commande pour tout ce que vous possédez — et tout ce que vous devriez posséder ensuite. Des actions aux cryptos, de l'immobilier aux montres, du DeFi aux secondaires Web3.",
    "landing.sub2": "Analyse de tendances par IA, opportunités d'investissement curées, et intelligence patrimoniale que les banquiers privés facturent 1%. Sauf qu'ici, c'est vous qui décidez.",
    "landing.cta": "Construisez Votre Patrimoine Gratuitement",
    "landing.nocredit": "Aucune information personnelle requise.",
    "landing.stat1": "Tout Actif",
    "landing.stat1sub": "Actions aux Supercars",
    "landing.stat2": "Propulsé par l'IA",
    "landing.stat2sub": "Risques & Recommandations",
    "landing.stat3": "Multi-Devises",
    "landing.stat3sub": "USD, EUR, BTC",
    "landing.stat4": "Deals Sélectionnés",
    "landing.stat4sub": "DeFi, Web3 & Plus",
    "landing.trackManage": "Suivre & Gérer",
    "landing.discoverBuild": "Découvrir & Construire",
    "landing.feat.everyAsset": "Tous Types d'Actifs",
    "landing.feat.everyAssetDesc": "Actions par ISIN, cryptos, matières premières, immobilier, montres, art, private equity. Si ça a de la valeur, c'est ici.",
    "landing.feat.charts": "Graphiques de Performance",
    "landing.feat.chartsDesc": "Performance historique sur 30J, 12M et tout temps. Suivez la trajectoire de votre patrimoine.",
    "landing.feat.credit": "Optimisation Crédit",

    // Landing
    "landing.feat.creditDesc": "Calculs LTV, mapping des garanties, échéanciers. Sachez exactement quel levier vous pouvez utiliser.",
    "landing.feat.reports": "Rapports PDF Auto",
    "landing.feat.reportsDesc": "Rapports patrimoniaux professionnels générés mensuellement. Téléchargez à tout moment. Comme un family office.",
    "landing.feat.advisor": "Conseiller IA",
    "landing.feat.advisorDesc": "Analyse de portefeuille, scoring de risque et recommandations actionnables par GPT. Un banquier privé qui travaille pour vous.",
    "landing.feat.macro": "Picks Macro-Dirigés",
    "landing.feat.macroDesc": "L'IA analyse les tendances mondiales pour identifier des actions et ETF par région — le type d'analyse que les conseillers Tier-1 gardent confidentiel.",
    "landing.feat.defi": "Deals DeFi & Web3",
    "landing.feat.defiDesc": "Rendements DeFi en direct, secondaires OTC Web3 d'Acquire.fi, et opportunités exclusives. De l'alpha, livré.",
    "landing.feat.risk": "Intelligence Risque",
    "landing.feat.riskDesc": "Chaque actif noté. Évaluation du risque à l'échelle du portefeuille. Sachez où vous êtes exposé avant que le marché ne vous le dise.",
    "landing.bottomTitle": "Arrêtez de Gérer Votre Patrimoine sur des Tableurs",
    "landing.bottomSub": "Votre patrimoine mérite mieux qu'un Google Sheet. Cableway Finance est le centre de commande que les gestionnaires de fortune facturent six chiffres — sauf que vous gardez le contrôle.",
    "landing.bottomCta": "Commencer Maintenant",
    "landing.tryDemo": "Voir la Démo",
    "landing.footer": "Cableway Finance. Votre patrimoine vers les sommets.",
    "landing.signin": "Connexion",

    // Dashboard
    "dash.title": "Tableau de bord",
    "dash.subtitle": "Votre portefeuille en un coup d'œil",
    "dash.totalValue": "Valeur Totale du Portefeuille",
    "dash.gainLoss": "Gain / Perte",
    "dash.netWorth": "Patrimoine Net",
    "dash.riskScore": "Risque du Portefeuille",
    "dash.historicalPerf": "Performance Historique",
    "dash.breakdown": "Répartition des Actifs",
    "dash.creditCapacity": "Capacité de Crédit",
    "dash.performance": "Performance",
    "dash.recentAssets": "Actifs Récents",
    "dash.recentCredits": "Crédits Récents",
    "dash.noAssets": "Aucun actif. Ajoutez votre premier actif pour voir la répartition.",
    "dash.noAssetsShort": "Aucun actif. Commencez à construire votre portefeuille !",
    "dash.noCredits": "Aucun crédit pour le moment",
    "dash.advisor": "Conseiller IA",
    "dash.advisorSub": "Analyses et recommandations pour votre portefeuille",
    "dash.refreshPrices": "Actualiser les Prix",
    "dash.updating": "Mise à jour...",
    "dash.allTime": "depuis le début",
    "dash.afterCredits": "Après {count} crédits",
    "dash.notEnoughData": "Pas assez de données",
    "dash.notEnoughDataSub": "Les données historiques sont capturées quotidiennement. Revenez demain pour votre premier graphique.",
    "dash.portfolioValue": "Valeur du Portefeuille",
    "dash.askPortfolio": "Posez une question sur votre portefeuille...",
    "dash.analyzing": "Analyse en cours...",
    "dash.annReturn": "Rend. Ann.",
    "dash.creditPayments": "Paiements Crédits/mois",
    "dash.assetsCredits": "Actifs / Crédits",
    "dash.available": "Disponible",
    "dash.totalCapacity": "Capacité Totale",
    "dash.used": "Utilisé",
    "dash.pl": "P/L",

    // Assets
    "assets.title": "Actifs",
    "assets.subtitle": "Gérez votre portefeuille d'investissement",
    "assets.addAsset": "Ajouter un Actif",
    "assets.addNew": "Ajouter un Nouvel Actif",
    "assets.editAsset": "Modifier l'Actif",
    "assets.enterDetails": "Entrez les détails de votre actif",
    "assets.updateDetails": "Mettre à jour les détails de l'actif",
    "assets.searchAssets": "Rechercher des actifs...",
    "assets.allTypes": "Tous les Types",
    "assets.noAssets": "Aucun actif trouvé",
    "assets.addFirst": "Ajoutez Votre Premier Actif",
    "assets.type": "Type",
    "assets.quantity": "Quantité",
    "assets.purchasePrice": "Prix d'Achat",
    "assets.currentPrice": "Prix Actuel",
    "assets.acquisitionDate": "Date d'Acquisition",
    "assets.currency": "Devise",
    "assets.ltv": "LTV (Prêt sur Valeur) %",
    "assets.riskScore": "Score de Risque",
    "assets.riskNotes": "Notes de Risque",
    "assets.notes": "Notes",
    "assets.category": "Catégorie",
    "assets.assetName": "Nom de l'Actif",
    "assets.searchCrypto": "Rechercher une Cryptomonnaie",
    "assets.searchStock": "Rechercher une Action (ou entrer un ISIN ci-dessous)",
    "assets.searchCommodity": "Rechercher une Matière Première",
    "assets.orEnterIsin": "Ou Entrer un ISIN",
    "assets.aiRiskAssessment": "Évaluation du Risque IA",
    "assets.recommendedRisk": "Score de Risque Recommandé",
    "assets.justification": "Justification",
    "assets.recommendations": "Recommandations",
    "assets.applyRisk": "Appliquer le Score",
    "assets.saveChanges": "Enregistrer",
    "assets.asset": "Actif",
    "assets.price": "Prix",
    "assets.value": "Valeur",
    "assets.held": "Détenu",
    "assets.risk": "Risque",
    "assets.actions": "Actions",
    "assets.cash": "Liquidités",
    "assets.accountName": "Nom du Compte",
    "assets.cashNamePlaceholder": "ex. Compte Courant, Livret A, Fonds d'Urgence...",
    "assets.cashSubcategory": "Type de Compte",
    "assets.selectAccountType": "Sélectionner le type de compte",
    "assets.cashChecking": "Compte Courant",
    "assets.cashSavings": "Épargne",
    "assets.cashMoneyMarket": "Marché Monétaire",
    "assets.cashCertificate": "Certificat de Dépôt",
    "assets.cashOther": "Autre",
    "assets.cashBalance": "Solde",
    "assets.addedSuccess": "Actif ajouté avec succès",
    "assets.addFailed": "Échec de l'ajout de l'actif",
    "assets.welcomeTitle": "Bienvenue dans Votre Portefeuille",
    "assets.welcomeSub": "Commencez en connectant votre banque, en utilisant l'assistant IA, ou en ajoutant des actifs manuellement.",
    "assets.onboardBank": "Connecter Votre Banque",
    "assets.onboardBankDesc": "Importez automatiquement vos comptes via Plaid — actions, liquidités et passifs.",
    "assets.onboardAI": "Configuration Guidée par l'IA",
    "assets.onboardAIDesc": "Ajoutez un actif et laissez notre IA évaluer son profil de risque et son adéquation.",
    "assets.onboardAIBtn": "Commencer avec l'IA",
    "assets.onboardManual": "Ajouter Manuellement",
    "assets.onboardManualDesc": "Saisissez vos actions, cryptos, immobilier ou tout type d'actif directement.",
    "assets.onboardDemoLocked": "Mode Démo",
    "assets.onboardBankDescPro": "Importez automatiquement vos comptes via l'Open Banking PSD2 sécurisé — actions, liquidités et passifs.",
    "assets.switchToPro": "Passer à PRO",
    "assets.proRequestSent": "Votre demande de mise à niveau PRO a été envoyée !",
    "assets.proRequestFailed": "Échec de l'envoi de la demande",
    "assets.aiAssistantTitle": "Assistant Portfolio IA",
    "assets.aiAssistantPlaceholder": "Posez des questions sur la construction de portfolio...",
    "assets.aiAssistantHint": "Demandez-moi tout sur la construction de votre portfolio",
    "plaid.connectBank": "Connecter Banque",
    "plaid.connectedBanks": "Banques Connectées",

    // Credits
    "credits.title": "Crédits",
    "credits.subtitle": "Gérez et suivez vos crédits",
    "credits.addCredit": "Ajouter un Crédit",
    "credits.creditType": "Type de Crédit",
    "credits.allTypes": "Tous les Types",
    "credits.typeMortgage": "Hypothèque",
    "credits.typeAutoLoan": "Prêt Auto",
    "credits.typeStudentLoan": "Prêt Étudiant",
    "credits.typePersonalLoan": "Prêt Personnel",
    "credits.typeBusinessLoan": "Prêt Professionnel",
    "credits.typeCreditCard": "Carte de Crédit",
    "credits.typeLombard": "Crédit Lombard",
    "credits.typeOther": "Autre",
    "credits.addNew": "Ajouter un Nouveau Crédit",
    "credits.editCredit": "Modifier le Crédit",
    "credits.enterDetails": "Entrez les détails de votre crédit/prêt",
    "credits.updateDetails": "Mettre à jour les détails du crédit",
    "credits.creditName": "Nom du Crédit",
    "credits.lender": "Prêteur",
    "credits.principal": "Montant Principal",
    "credits.outstanding": "Montant Restant",
    "credits.interestRate": "Taux d'Intérêt (%)",
    "credits.monthlyPayment": "Mensualité",
    "credits.startDate": "Date de Début",
    "credits.termMonths": "Durée (mois)",
    "credits.calculatedEnd": "Date de Fin Calculée",
    "credits.setStartTerm": "Définir la date de début et la durée",
    "credits.paymentDate": "Date de Paiement dans le Mois",
    "credits.paymentBeginning": "Début du mois (1er-5)",
    "credits.paymentMid": "Mi-mois (13-17)",
    "credits.paymentEnd": "Fin du mois (25-30)",
    "credits.collateral": "Actif de Garantie",
    "credits.noCollateral": "Aucun (pas de garantie)",
    "credits.other": "Autre",
    "credits.noCredits": "Aucun crédit",
    "credits.addFirst": "Ajoutez Votre Premier Crédit",
    "credits.yourCredits": "Vos Crédits",
    "credits.totalPaid": "Total Payé",
    "credits.paidLastMonth": "Payé le Mois Dernier",
    "credits.totalRemaining": "Total Restant",
    "credits.nextMonth": "Mois Prochain",
    "credits.creditCapacity": "Capacité de Crédit",
    "credits.utilization": "Utilisation",
    "credits.totalCapacity": "Capacité Totale",
    "credits.available": "Disponible",
    "credits.totalOutstanding": "Total Restant Dû",
    "credits.monthlyPayments": "Mensualités",
    "credits.totalPerMonth": "Total par mois",
    "credits.activeCredits": "crédit actif",
    "credits.activeCreditsPlural": "crédits actifs",
    "credits.credit": "Crédit",
    "credits.rate": "Taux",
    "credits.monthly": "Mensualité",
    "credits.payment": "Paiement",
    "credits.saveChanges": "Enregistrer",
    "credits.deleteCredit": "Supprimer le Crédit",
    "credits.notes": "Notes",
    "credits.tipTotalPaid": "Montant cumulé remboursé sur tous vos crédits depuis leur début, basé sur les mensualités et les mois écoulés.",
    "credits.tipPaidLastMonth": "Somme des mensualités de tous les crédits actifs pour le dernier mois calendaire.",
    "credits.tipTotalRemaining": "Solde total restant dû sur l'ensemble de vos crédits (capital non encore remboursé).",
    "credits.tipNextMonth": "Paiement total projeté pour le mois prochain sur tous les crédits actifs.",
    "credits.tipCreditCapacity": "Capacité d'emprunt maximale basée sur les ratios LTV de vos actifs. Disponible = Capacité totale moins Crédit utilisé.",
    "credits.tipUtilization": "Pourcentage de votre capacité d'emprunt totale actuellement utilisée. Plus bas = plus sain.",
    "credits.tipTotalOutstanding": "Somme des soldes restants sur toutes vos positions de crédit.",
    "credits.tipMonthlyPayments": "Somme de toutes les obligations de paiement mensuel sur vos crédits actifs.",

    // Opportunities
    "opps.title": "Opportunités",
    "opps.subtitle": "Découvrez des opportunités d'investissement",
    "opps.refresh": "Actualiser",
    "opps.addManual": "Ajouter une Opportunité",
    "opps.addOpportunity": "Ajouter une Opportunité",
    "opps.addCustom": "Ajouter une opportunité d'investissement personnalisée",
    "opps.saveOpportunity": "Ajouter l'Opportunité",
    "opps.web3": "Secondaires Web3",
    "opps.myDeals": "Mes Deals",
    "opps.defi": "DeFi",
    "opps.commodities": "Matières Premières",
    "opps.stocks": "Actions",
    "opps.others": "Autres",
    "opps.recommended": "Recommandé par Cableway",
    "opps.oppsFound": "Opportunités Trouvées",
    "opps.avgApy": "APY Moyen",
    "opps.totalTvl": "TVL Total Suivi",
    "opps.availableOpps": "Opportunités Disponibles",
    "opps.noOpps": "Aucune opportunité correspondant à vos filtres",
    "opps.refreshOpps": "Actualiser les Opportunités",
    "opps.visitVault": "Voir le Vault",
    "opps.refreshData": "Actualiser les Données",
    "opps.scraping": "Extraction...",
    "opps.lastRefresh": "Dernière mise à jour",
    "opps.totalListings": "Total des Annonces",
    "opps.selling": "Vente",
    "opps.buying": "Achat",
    "opps.viewDeal": "Voir l'Offre",
    "opps.contact": "Contact",
    "opps.noAltData": "Aucune donnée disponible",
    "opps.noAltResults": "Aucun résultat ne correspond à vos filtres",
    "opps.clickRefresh": "Cliquez sur \"Actualiser\" pour obtenir les dernières offres OTC d'Acquire.Fi",
    "opps.tryFilters": "Essayez d'ajuster vos filtres",
    "opps.refreshTrends": "Actualiser les Tendances",
    "opps.analyzing": "Analyse...",
    "opps.allRegions": "Toutes les Régions",
    "opps.noStockTrends": "Aucune donnée de tendance",
    "opps.clickRefreshTrends": "Cliquez sur \"Actualiser\" pour obtenir des recommandations IA",
    "opps.eurUsdChart": "Taux de Change EUR/USD (1 An)",
    "opps.portfolioFit": "Adéquation Portefeuille",
    "opps.name": "Nom",
    "opps.category": "Catégorie",
    "opps.description": "Description",
    "opps.type": "Type (texte libre)",
    "opps.expectedReturn": "Rendement Attendu",
    "opps.price": "Prix",
    "opps.ticketMin": "Ticket Min",
    "opps.url": "URL (optionnel)",
    "opps.riskScore": "Score de Risque",
    "opps.protocol": "Protocole",
    "opps.chain": "Chaîne",
    "opps.apy": "APY (%)",
    "opps.tvl": "TVL (USD)",
    "opps.token": "Jeton",
    "opps.imageUrl": "URL de l'Image",
    "opps.notes": "Notes",
    "opps.search": "Rechercher",
    "opps.categoryFilter": "Catégorie",
    "opps.typeFilter": "Type",
    "opps.minTicket": "Ticket Min",
    "opps.anyAmount": "Tout Montant",
    "opps.minTvl": "TVL Min",
    "opps.tokenFilter": "Filtre Jeton",
    "opps.minApy": "APY Min (%)",
    "opps.maxApy": "APY Max (%)",
    "opps.riskLevel": "Niveau de Risque",
    "opps.allRisks": "Tous les Risques",
    "opps.lowRisk": "Risque Faible",
    "opps.mediumRisk": "Risque Moyen",
    "opps.highRisk": "Risque Élevé",
    "opps.sortBy": "Trier Par",
    "opps.highestApy": "APY le Plus Élevé",
    "opps.highestTvl": "TVL le Plus Élevé",
    "opps.lowestRisk": "Risque le Plus Faible",
    "opps.apply": "Appliquer",
    "opps.manualOpps": "Vos Opportunités Manuelles",
    "opps.noManualOpps": "Aucune opportunité manuelle",

    // Reports
    "reports.title": "Rapports",
    "reports.sub": "Les rapports mensuels sont générés automatiquement le 1er. Vous pouvez aussi en générer un manuellement (1x/jour).",
    "reports.generate": "Générer un Rapport",
    "reports.generating": "Génération...",
    "reports.history": "Historique des Rapports",
    "reports.noReports": "Aucun rapport",
    "reports.noReportsSub": "Cliquez sur \"Générer un Rapport\" pour créer votre premier rapport.",
    "reports.date": "Date",
    "reports.month": "Mois",
    "reports.type": "Type",
    "reports.portfolioValue": "Valeur du Portefeuille",
    "reports.pl": "P/L",
    "reports.assets": "Actifs",
    "reports.actions": "Actions",

    // Admin
    "admin.title": "Administration",
    "admin.subtitle": "Gérez les utilisateurs et les opportunités",
    "admin.users": "Utilisateurs",
    "admin.pushedOpps": "Opportunités Publiées",
    "admin.accessDenied": "Accès Refusé",
    "admin.noPrivileges": "Vous n'avez pas les privilèges administrateur.",
    "admin.searchUsers": "Rechercher des utilisateurs...",
    "admin.user": "Utilisateur",
    "admin.status": "Statut",
    "admin.portfolio": "Portefeuille",
    "admin.assetsCount": "Actifs",
    "admin.lastLogin": "Dernière Connexion",
    "admin.actions": "Actions",
    "admin.backToList": "Retour à la liste",
    "admin.removeAdmin": "Retirer Admin",
    "admin.makeAdmin": "Rendre Admin",
    "admin.generateReport": "Générer un Rapport",
    "admin.confirmAdminChange": "Confirmer le Changement de Statut",
    "admin.removeAdminMsg": "Retirer les privilèges admin de {name} ?",
    "admin.grantAdminMsg": "Accorder les privilèges admin à {name} ({email}) ?",
    "admin.newOpportunity": "Nouvelle Opportunité",
    "admin.createOpp": "Créer une Opportunité",
    "admin.editOpp": "Modifier l'Opportunité",
    "admin.oppPushed": "Ceci sera publié comme opportunité \"Recommandé par Cableway\"",
    "admin.deleteOpp": "Supprimer l'Opportunité",
    "admin.deleteOppMsg": "Supprimer \"{name}\" ? Cela la retirera de tous les utilisateurs.",
    "admin.target": "Cible",
    "admin.allUsers": "Tous les Utilisateurs",
    "admin.selectedUsers": "Utilisateurs Sélectionnés",
    "admin.published": "Publié",
    "admin.expires": "Expire",
    "admin.noPublished": "Aucune opportunité publiée",
    "admin.pushFirst": "Publiez votre première recommandation",
    "admin.publicationDate": "Date de Publication",
    "admin.expirationDate": "Date d'Expiration",
    "admin.noUsers": "Aucun utilisateur trouvé",
    "admin.portfolioValue": "Valeur du Portefeuille",

    // Settings
    "settings.title": "Paramètres",
    "settings.subtitle": "Gérez les préférences de votre compte",
    "settings.profile": "Profil",
    "settings.profileDesc": "Vos informations de compte",
    "settings.appearance": "Apparence",
    "settings.appearanceDesc": "Personnalisez l'apparence",
    "settings.theme": "Thème",
    "settings.themeDesc": "Basculer entre le mode clair et sombre",
    "settings.light": "Clair",
    "settings.dark": "Sombre",
    "settings.displayCurrency": "Devise d'Affichage",
    "settings.displayCurrencyDesc": "Choisissez comment afficher les valeurs monétaires",
    "settings.language": "Langue",
    "settings.languageDesc": "Choisissez votre langue d'affichage préférée",
    "settings.languageConvert": "Tous les textes seront affichés dans cette langue",
    "settings.currencyLabel": "Devise",
    "settings.currencyConvert": "Toutes les valeurs seront converties dans cette devise",
    "settings.security": "Sécurité",
    "settings.securityDesc": "Gérez la sécurité de votre compte",
    "settings.investPrefs": "Préférences d'Investissement",
    "settings.investPrefsDesc": "Configurez votre profil d'investissement et la visibilité des opportunités",
    "settings.riskTolerance": "Tolérance au Risque",
    "settings.riskToleranceDesc": "Influence le score d'adéquation au portefeuille pour les recommandations",
    "settings.risk_conservative": "Prudent",
    "settings.risk_moderate": "Modéré",
    "settings.risk_aggressive": "Agressif",
    "settings.preferredRegions": "Régions Préférées",
    "settings.preferredRegionsDesc": "Sélectionnez les régions boursières qui vous intéressent le plus",
    "settings.visibleChannels": "Canaux d'Opportunités Visibles",
    "settings.visibleChannelsDesc": "Choisissez quels onglets d'opportunités afficher",
    "settings.googleConnected": "Connecté avec Google",
    "settings.googleAuth": "Votre compte est authentifié de manière sécurisée via Google",
    "settings.signOut": "Déconnexion",
    "settings.signOutDesc": "Se déconnecter de votre compte sur cet appareil",
    "settings.version": "Cableway Finance v1.0.0",
    "settings.builtFor": "Votre patrimoine vers les sommets",

    // Common
    "common.loading": "Chargement...",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.add": "Ajouter",
    "common.search": "Rechercher",
    "common.name": "Nom",
    "common.type": "Type",
    "common.value": "Valeur",
    "common.date": "Date",
    "common.actions": "Actions",
    "common.previous": "Précédent",
    "common.next": "Suivant",
    "common.page": "Page",
    "common.of": "de",
    "common.results": "résultats",
    "common.never": "Jamais",
    "common.publish": "Publier",
    "common.update": "Mettre à jour",

    // Budget
    "nav.budget": "Budget",
    "budget.title": "Budget",
    "budget.subtitle": "Suivez vos revenus et dépenses",
    "budget.refresh": "Actualiser",
    "budget.monthlyIncome": "Revenus Mensuels",
    "budget.monthlyIncomeTooltip": "Total des revenus récurrents convertis en équivalent mensuel",
    "budget.monthlyExpenses": "Dépenses Mensuelles",
    "budget.monthlyExpensesTooltip": "Dépenses récurrentes définies par l'utilisateur converties en mensuel",
    "budget.creditPayments": "Paiements de Crédits",
    "budget.creditPaymentsTooltip": "Paiements mensuels de vos crédits/passifs",
    "budget.netCashFlow": "Flux de Trésorerie Net",
    "budget.netCashFlowTooltip": "Revenus moins toutes les dépenses et paiements de crédits",
    "budget.perMonth": "/mois",
    "budget.sources": "sources",
    "budget.items": "éléments",
    "budget.credits": "crédits",
    "budget.budgetHealth": "Santé du Budget",
    "budget.budgetHealthTooltip": "Basé sur le taux d'épargne : 30%+ = Excellent, 20%+ = Bon, 10%+ = Acceptable, 0%+ = À Risque, Négatif = Critique",
    "budget.savingsRate": "Taux d'Épargne",
    "budget.projection6m": "Projection 6 Mois",
    "budget.projection12m": "Projection 12 Mois",
    "budget.projectionDesc": "Basé sur le flux de trésorerie actuel",
    "budget.cashReserves": "Réserves de Trésorerie",
    "budget.runway": "Autonomie",
    "budget.months": "mois",
    "budget.incomeSources": "Sources de Revenus",
    "budget.incomeSourcesDesc": "Flux de revenus récurrents",
    "budget.expenses": "Dépenses",
    "budget.expensesDesc": "Sorties récurrentes",
    "budget.addIncome": "Ajouter un Revenu",
    "budget.addExpense": "Ajouter une Dépense",
    "budget.editIncome": "Modifier le Revenu",
    "budget.editExpense": "Modifier la Dépense",
    "budget.source": "Source",
    "budget.expense": "Dépense",
    "budget.category": "Catégorie",
    "budget.monthly": "Mensuel",
    "budget.actions": "Actions",
    "budget.edit": "Modifier",
    "budget.delete": "Supprimer",
    "budget.noIncome": "Aucune source de revenus",
    "budget.noExpenses": "Aucune dépense",
    "budget.addFirst": "Ajouter votre première source de revenus",
    "budget.addFirstExpense": "Ajouter votre première dépense",
    "budget.creditPaymentsBreakdown": "Détail des Paiements de Crédits",
    "budget.creditPaymentsBreakdownDesc": "Paiements mensuels de vos passifs",
    "budget.creditName": "Crédit",
    "budget.type": "Type",
    "budget.monthlyPayment": "Paiement Mensuel",
    "budget.incomeFormDesc": "Entrez les détails de cette source de revenus",
    "budget.expenseFormDesc": "Entrez les détails de cette dépense",
    "budget.name": "Nom",
    "budget.frequency": "Fréquence",
    "budget.amount": "Montant",
    "budget.currency": "Devise",
    "budget.startDate": "Date de Début",
    "budget.optional": "optionnel",
    "budget.cancel": "Annuler",
    "budget.add": "Ajouter",
    "budget.update": "Mettre à jour",
    "budget.incomeAdded": "Revenu ajouté",
    "budget.incomeUpdated": "Revenu mis à jour",
    "budget.expenseAdded": "Dépense ajoutée",
    "budget.expenseUpdated": "Dépense mise à jour",
    "budget.saveFailed": "Échec de l'enregistrement",
    "budget.deleted": "Supprimé avec succès",
    "budget.deleteFailed": "Échec de la suppression",
    "budget.deleteIncome": "Supprimer le Revenu",
    "budget.deleteExpense": "Supprimer la Dépense",
    "budget.fetchError": "Échec du chargement des données budgétaires",
    "budget.predictionsChart": "Prévisions sur 12 Mois",
    "budget.predictionsChartDesc": "Revenus projetés vs. dépenses",
    "budget.monthlyAvg": "Moyenne Mensuelle",
    "budget.recurring": "Récurrent",
    "budget.income": "Revenus",
    "budget.totalExpenses": "Dépenses Totales",
    "budget.noDataForChart": "Ajoutez des revenus ou dépenses pour voir les projections",
    "budget.passiveIncome": "Revenus Passifs",
    "budget.passiveIncomeDesc": "Revenus nécessitant un effort minimal",
    "budget.yearly": "Annuel",
    "budget.passiveRatio": "Ratio passif",
    "budget.ofTotalIncome": "du revenu total",
    "budget.noPassiveIncome": "Aucun revenu passif pour l'instant",
    "budget.markAsPassive": "Marquez les sources de revenus comme passives lors de l'ajout",
    "budget.passiveIncomeLabel": "C'est un revenu passif",
    "budget.passiveIncomeHint": "ex: dividendes, loyers, intérêts - revenus nécessitant peu d'effort",
    "budget.passive": "Passif",
  },

  es: {
    // Navigation
    "nav.dashboard": "Panel",
    "nav.assets": "Activos",
    "nav.credits": "Créditos",
    "nav.opportunities": "Oportunidades",
    "nav.reports": "Informes",
    "nav.settings": "Ajustes",
    "nav.admin": "Administración",
    "nav.logout": "Cerrar Sesión",
    "nav.displayCurrency": "Moneda de visualización",
    "nav.language": "Idioma",
    "nav.lightMode": "Modo claro",
    "nav.darkMode": "Modo oscuro",
    "nav.myDeals": "Mis Deals",
    "nav.defi": "DeFi",
    "nav.stocks": "Acciones",
    "nav.web3": "Secundarios Web3",
    "nav.commodities": "Materias Primas",
    "landing.tagline": "Tu Patrimonio, Optimizado",
    "landing.badge": "Seguir, Descubrir, Construir",
    "landing.hero1": "El Asesor Financiero",
    "landing.hero2": "Que Sí Puedes Pagar",
    "landing.sub1": "Un centro de control para todo lo que posees — y todo lo que deberías poseer después. Desde acciones hasta cripto, inmuebles hasta relojes, rendimientos DeFi hasta secundarios Web3.",
    "landing.sub2": "Análisis de tendencias con IA, oportunidades de inversión curadas, e inteligencia patrimonial que los banqueros privados cobran 1% por ofrecer. Excepto que aquí, tú tienes el control.",
    "landing.cta": "Construye Tu Patrimonio Gratis",
    "landing.nocredit": "No se necesita información privada.",
    "landing.stat1": "Cualquier Activo",
    "landing.stat1sub": "Acciones a Supercoches",
    "landing.stat2": "Con IA",
    "landing.stat2sub": "Riesgo & Recomendaciones",
    "landing.stat3": "Multi-Moneda",
    "landing.stat3sub": "USD, EUR, BTC",
    "landing.stat4": "Ofertas Curadas",
    "landing.stat4sub": "DeFi, Web3 & Más",
    "landing.trackManage": "Seguir & Gestionar",
    "landing.discoverBuild": "Descubrir & Construir",
    "landing.feat.everyAsset": "Todo Tipo de Activo",
    "landing.feat.everyAssetDesc": "Acciones por ISIN, cripto, materias primas, inmuebles, relojes, arte, private equity. Si tiene valor, va aquí.",
    "landing.feat.charts": "Gráficos de Rendimiento",
    "landing.feat.chartsDesc": "Rendimiento histórico con vistas de 30D, 12M y todo el tiempo. Sigue la trayectoria de tu patrimonio.",
    "landing.feat.credit": "Optimización de Crédito",
    "landing.feat.creditDesc": "Cálculos LTV, mapeo de garantías, calendarios de pago. Sabe exactamente cuánto apalancamiento puedes usar.",
    "landing.feat.reports": "Informes PDF Auto",
    "landing.feat.reportsDesc": "Informes patrimoniales profesionales generados mensualmente. Descarga en cualquier momento.",
    "landing.feat.advisor": "Asesor IA",
    "landing.feat.advisorDesc": "Análisis de cartera, puntuación de riesgo y recomendaciones accionables con GPT. Como un banquero privado que trabaja para ti.",
    "landing.feat.macro": "Selecciones Macro",

    // Landing
    "landing.feat.macroDesc": "La IA escanea tendencias globales para identificar acciones y ETFs por región — el tipo de análisis que los asesores Tier-1 mantienen confidencial.",
    "landing.feat.defi": "Ofertas DeFi & Web3",
    "landing.feat.defiDesc": "Rendimientos DeFi en vivo, secundarios OTC Web3 de Acquire.fi, y oportunidades exclusivas curadas.",
    "landing.feat.risk": "Inteligencia de Riesgo",
    "landing.feat.riskDesc": "Cada activo puntuado. Evaluación de riesgo a nivel de cartera. Sabe dónde estás expuesto antes de que el mercado te lo diga.",
    "landing.bottomTitle": "Deja de Gestionar tu Patrimonio en Hojas de Cálculo",
    "landing.bottomSub": "Tu patrimonio merece algo mejor que un Google Sheet. Cableway Finance es el centro de control que los gestores de patrimonio cobran seis cifras por ofrecer — excepto que aquí tú tienes el control.",
    "landing.bottomCta": "Comenzar Ahora",
    "landing.tryDemo": "Ver una Demo",
    "landing.footer": "Cableway Finance. Llevando tu patrimonio a la cima.",
    "landing.signin": "Iniciar Sesión",

    // Dashboard
    "dash.title": "Panel",
    "dash.subtitle": "Tu portafolio de un vistazo",
    "dash.totalValue": "Valor Total del Portafolio",
    "dash.gainLoss": "Ganancia / Pérdida",
    "dash.netWorth": "Patrimonio Neto",
    "dash.riskScore": "Riesgo del Portafolio",
    "dash.historicalPerf": "Rendimiento Histórico",
    "dash.breakdown": "Desglose de Activos",
    "dash.creditCapacity": "Capacidad de Crédito",
    "dash.performance": "Rendimiento",
    "dash.recentAssets": "Activos Recientes",
    "dash.recentCredits": "Créditos Recientes",
    "dash.noAssets": "Sin activos. Agrega tu primer activo para ver el desglose.",
    "dash.noAssetsShort": "Sin activos. Empieza a construir tu portafolio!",
    "dash.noCredits": "Sin créditos aún",
    "dash.advisor": "Asesor IA",
    "dash.advisorSub": "Análisis y recomendaciones para tu portafolio",
    "dash.refreshPrices": "Actualizar Precios",
    "dash.updating": "Actualizando...",
    "dash.allTime": "desde el inicio",
    "dash.afterCredits": "Después de {count} créditos",
    "dash.notEnoughData": "Datos insuficientes",
    "dash.notEnoughDataSub": "Los datos históricos se capturan diariamente. Vuelve mañana para tu primer gráfico.",
    "dash.portfolioValue": "Valor del Portafolio",
    "dash.askPortfolio": "Pregunta sobre tu portafolio...",
    "dash.analyzing": "Analizando...",
    "dash.annReturn": "Rend. Anual",
    "dash.creditPayments": "Pagos Créditos/mes",
    "dash.assetsCredits": "Activos / Créditos",
    "dash.available": "Disponible",
    "dash.totalCapacity": "Capacidad Total",
    "dash.used": "Usado",
    "dash.pl": "G/P",

    // Assets
    "assets.title": "Activos",
    "assets.subtitle": "Gestiona tu portafolio de inversiones",
    "assets.addAsset": "Agregar Activo",
    "assets.addNew": "Agregar Nuevo Activo",
    "assets.editAsset": "Editar Activo",
    "assets.enterDetails": "Ingresa los detalles de tu activo",
    "assets.updateDetails": "Actualizar detalles del activo",
    "assets.searchAssets": "Buscar activos...",
    "assets.allTypes": "Todos los Tipos",
    "assets.noAssets": "No se encontraron activos",
    "assets.addFirst": "Agrega Tu Primer Activo",
    "assets.type": "Tipo",
    "assets.quantity": "Cantidad",
    "assets.purchasePrice": "Precio de Compra",
    "assets.currentPrice": "Precio Actual",
    "assets.acquisitionDate": "Fecha de Adquisición",
    "assets.currency": "Moneda",
    "assets.ltv": "LTV (Préstamo sobre Valor) %",
    "assets.riskScore": "Puntuación de Riesgo",
    "assets.riskNotes": "Notas de Riesgo",
    "assets.notes": "Notas",
    "assets.category": "Categoría",
    "assets.assetName": "Nombre del Activo",
    "assets.searchCrypto": "Buscar Criptomoneda",
    "assets.searchStock": "Buscar Acción (o ingresa ISIN abajo)",
    "assets.searchCommodity": "Buscar Materia Prima",
    "assets.orEnterIsin": "O Ingresar ISIN",
    "assets.aiRiskAssessment": "Evaluación de Riesgo IA",
    "assets.recommendedRisk": "Puntuación de Riesgo Recomendada",
    "assets.justification": "Justificación",
    "assets.recommendations": "Recomendaciones",
    "assets.applyRisk": "Aplicar Puntuación",
    "assets.saveChanges": "Guardar Cambios",
    "assets.asset": "Activo",
    "assets.price": "Precio",
    "assets.value": "Valor",
    "assets.held": "Tenencia",
    "assets.risk": "Riesgo",
    "assets.actions": "Acciones",
    "assets.cash": "Efectivo",
    "assets.accountName": "Nombre de la Cuenta",
    "assets.cashNamePlaceholder": "ej. Cuenta Corriente, Fondo de Emergencia...",
    "assets.cashSubcategory": "Tipo de Cuenta",
    "assets.selectAccountType": "Seleccionar tipo de cuenta",
    "assets.cashChecking": "Cuenta Corriente",
    "assets.cashSavings": "Ahorros",
    "assets.cashMoneyMarket": "Mercado Monetario",
    "assets.cashCertificate": "Certificado de Depósito",
    "assets.cashOther": "Otro",
    "assets.cashBalance": "Saldo",
    "assets.addedSuccess": "Activo agregado con éxito",
    "assets.addFailed": "Error al agregar el activo",
    "assets.welcomeTitle": "Bienvenido a Tu Portafolio",
    "assets.welcomeSub": "Comienza conectando tu banco, usando el asistente IA, o agregando activos manualmente.",
    "assets.onboardBank": "Conectar Tu Banco",
    "assets.onboardBankDesc": "Importa automáticamente tus cuentas vía Plaid — acciones, efectivo y pasivos.",
    "assets.onboardAI": "Configuración Guiada por IA",
    "assets.onboardAIDesc": "Agrega un activo y deja que nuestra IA evalúe su perfil de riesgo y ajuste.",
    "assets.onboardAIBtn": "Empezar con IA",
    "assets.onboardManual": "Agregar Manualmente",
    "assets.onboardManualDesc": "Ingresa tus acciones, cripto, inmuebles o cualquier tipo de activo directamente.",
    "assets.onboardDemoLocked": "Modo Demo",
    "assets.onboardBankDescPro": "Importa automáticamente tus cuentas a través de Open Banking PSD2 seguro — acciones, efectivo y pasivos.",
    "assets.switchToPro": "Cambiar a PRO",
    "assets.proRequestSent": "¡Tu solicitud de actualización PRO ha sido enviada!",
    "assets.proRequestFailed": "Error al enviar la solicitud",
    "assets.aiAssistantTitle": "Asistente de Portfolio IA",
    "assets.aiAssistantPlaceholder": "Pregunta sobre la construcción de portfolio...",
    "assets.aiAssistantHint": "Pregúntame cualquier cosa sobre la construcción de tu portfolio",
    "plaid.connectBank": "Conectar Banco",
    "plaid.connectedBanks": "Bancos Conectados",

    // Credits
    "credits.title": "Créditos",
    "credits.subtitle": "Gestiona y sigue tus créditos",
    "credits.addCredit": "Agregar Crédito",
    "credits.creditType": "Tipo de Crédito",
    "credits.allTypes": "Todos los Tipos",
    "credits.typeMortgage": "Hipoteca",
    "credits.typeAutoLoan": "Préstamo Auto",
    "credits.typeStudentLoan": "Préstamo Estudiantil",
    "credits.typePersonalLoan": "Préstamo Personal",
    "credits.typeBusinessLoan": "Préstamo Comercial",
    "credits.typeCreditCard": "Tarjeta de Crédito",
    "credits.typeLombard": "Crédito Lombard",
    "credits.typeOther": "Otro",
    "credits.addNew": "Agregar Nuevo Crédito",
    "credits.editCredit": "Editar Crédito",
    "credits.enterDetails": "Ingresa los detalles de tu crédito/préstamo",
    "credits.updateDetails": "Actualizar detalles del crédito",
    "credits.creditName": "Nombre del Crédito",
    "credits.lender": "Prestamista",
    "credits.principal": "Monto Principal",
    "credits.outstanding": "Monto Pendiente",
    "credits.interestRate": "Tasa de Interés (%)",
    "credits.monthlyPayment": "Pago Mensual",
    "credits.startDate": "Fecha de Inicio",
    "credits.termMonths": "Plazo (meses)",
    "credits.calculatedEnd": "Fecha de Fin Calculada",
    "credits.setStartTerm": "Definir fecha de inicio y plazo",
    "credits.paymentDate": "Fecha de Pago en el Mes",
    "credits.paymentBeginning": "Inicio del mes (1-5)",
    "credits.paymentMid": "Mediados de mes (13-17)",
    "credits.paymentEnd": "Fin del mes (25-30)",
    "credits.collateral": "Activo de Garantía",
    "credits.noCollateral": "Ninguno (sin garantía)",
    "credits.other": "Otro",
    "credits.noCredits": "Sin créditos",
    "credits.addFirst": "Agrega Tu Primer Crédito",
    "credits.yourCredits": "Tus Créditos",
    "credits.totalPaid": "Total Pagado",
    "credits.paidLastMonth": "Pagado el Mes Pasado",
    "credits.totalRemaining": "Total Restante",
    "credits.nextMonth": "Próximo Mes",
    "credits.creditCapacity": "Capacidad de Crédito",
    "credits.utilization": "Utilización",
    "credits.totalCapacity": "Capacidad Total",
    "credits.available": "Disponible",
    "credits.totalOutstanding": "Total Pendiente",
    "credits.monthlyPayments": "Pagos Mensuales",
    "credits.totalPerMonth": "Total por mes",
    "credits.activeCredits": "crédito activo",
    "credits.activeCreditsPlural": "créditos activos",
    "credits.credit": "Crédito",
    "credits.rate": "Tasa",
    "credits.monthly": "Mensual",
    "credits.payment": "Pago",
    "credits.saveChanges": "Guardar Cambios",
    "credits.deleteCredit": "Eliminar Crédito",
    "credits.notes": "Notas",
    "credits.tipTotalPaid": "Monto acumulado reembolsado en todos tus créditos desde su inicio, basado en pagos mensuales y meses transcurridos.",
    "credits.tipPaidLastMonth": "Suma de pagos mensuales de todos los créditos activos del último mes calendario.",
    "credits.tipTotalRemaining": "Saldo total pendiente en todos tus créditos (capital aún no reembolsado).",
    "credits.tipNextMonth": "Pago total proyectado para el próximo mes en todos los créditos activos.",
    "credits.tipCreditCapacity": "Capacidad máxima de endeudamiento basada en los ratios LTV de tus activos. Disponible = Capacidad total menos Crédito utilizado.",
    "credits.tipUtilization": "Porcentaje de tu capacidad de endeudamiento total actualmente en uso. Menor es más saludable.",
    "credits.tipTotalOutstanding": "Suma de saldos pendientes en todas tus posiciones de crédito.",
    "credits.tipMonthlyPayments": "Suma de todas las obligaciones de pago mensual en tus créditos activos.",

    // Opportunities
    "opps.title": "Oportunidades",
    "opps.subtitle": "Descubre oportunidades de inversión",
    "opps.refresh": "Actualizar",
    "opps.addManual": "Agregar Oportunidad",
    "opps.addOpportunity": "Agregar Oportunidad",
    "opps.addCustom": "Agrega una oportunidad de inversión personalizada",
    "opps.saveOpportunity": "Agregar Oportunidad",
    "opps.myDeals": "Mis Deals",
    "opps.defi": "DeFi",
    "opps.commodities": "Materias Primas",
    "opps.web3": "Secundarios Web3",
    "opps.stocks": "Acciones",
    "opps.others": "Otros",
    "opps.recommended": "Recomendado por Cableway",
    "opps.oppsFound": "Oportunidades Encontradas",
    "opps.avgApy": "APY Promedio",
    "opps.totalTvl": "TVL Total Rastreado",
    "opps.availableOpps": "Oportunidades Disponibles",
    "opps.noOpps": "No se encontraron oportunidades con tus filtros",
    "opps.refreshOpps": "Actualizar Oportunidades",
    "opps.visitVault": "Ver Vault",
    "opps.refreshData": "Actualizar Datos",
    "opps.scraping": "Extrayendo...",
    "opps.lastRefresh": "Última actualización",
    "opps.totalListings": "Total de Listados",
    "opps.selling": "Venta",
    "opps.buying": "Compra",
    "opps.viewDeal": "Ver Oferta",
    "opps.contact": "Contacto",
    "opps.noAltData": "Sin datos disponibles",
    "opps.noAltResults": "No hay resultados con tus filtros",
    "opps.clickRefresh": "Haz clic en \"Actualizar\" para obtener las últimas ofertas OTC de Acquire.Fi",
    "opps.tryFilters": "Intenta ajustar tus filtros",
    "opps.refreshTrends": "Actualizar Tendencias",
    "opps.analyzing": "Analizando...",
    "opps.allRegions": "Todas las Regiones",
    "opps.noStockTrends": "Sin datos de tendencias",
    "opps.clickRefreshTrends": "Haz clic en \"Actualizar\" para obtener recomendaciones IA",
    "opps.eurUsdChart": "Tipo de Cambio EUR/USD (1 Año)",
    "opps.portfolioFit": "Ajuste al Portafolio",
    "opps.name": "Nombre",
    "opps.category": "Categoría",
    "opps.description": "Descripción",
    "opps.type": "Tipo (texto libre)",
    "opps.expectedReturn": "Retorno Esperado",
    "opps.price": "Precio",
    "opps.ticketMin": "Ticket Min",
    "opps.url": "URL (opcional)",
    "opps.riskScore": "Puntuación de Riesgo",
    "opps.protocol": "Protocolo",
    "opps.chain": "Cadena",
    "opps.apy": "APY (%)",
    "opps.tvl": "TVL (USD)",
    "opps.token": "Token",
    "opps.imageUrl": "URL de Imagen",
    "opps.notes": "Notas",
    "opps.search": "Buscar",
    "opps.categoryFilter": "Categoría",
    "opps.typeFilter": "Tipo",
    "opps.minTicket": "Ticket Min",
    "opps.anyAmount": "Cualquier Monto",
    "opps.minTvl": "TVL Min",
    "opps.tokenFilter": "Filtro Token",
    "opps.minApy": "APY Min (%)",
    "opps.maxApy": "APY Max (%)",
    "opps.riskLevel": "Nivel de Riesgo",
    "opps.allRisks": "Todos los Riesgos",
    "opps.lowRisk": "Riesgo Bajo",
    "opps.mediumRisk": "Riesgo Medio",
    "opps.highRisk": "Riesgo Alto",
    "opps.sortBy": "Ordenar Por",
    "opps.highestApy": "Mayor APY",
    "opps.highestTvl": "Mayor TVL",
    "opps.lowestRisk": "Menor Riesgo",
    "opps.apply": "Aplicar",
    "opps.manualOpps": "Tus Oportunidades Manuales",
    "opps.noManualOpps": "Sin oportunidades manuales",

    // Reports
    "reports.title": "Informes",
    "reports.sub": "Los informes mensuales se generan automáticamente el 1ro. También puedes generar uno manualmente (1x/día).",
    "reports.generate": "Generar Informe",
    "reports.generating": "Generando...",
    "reports.history": "Historial de Informes",
    "reports.noReports": "Sin informes",
    "reports.noReportsSub": "Haz clic en \"Generar Informe\" para crear tu primer informe.",
    "reports.date": "Fecha",
    "reports.month": "Mes",
    "reports.type": "Tipo",
    "reports.portfolioValue": "Valor del Portafolio",
    "reports.pl": "G/P",
    "reports.assets": "Activos",
    "reports.actions": "Acciones",

    // Admin
    "admin.title": "Administración",
    "admin.subtitle": "Gestiona usuarios y oportunidades",
    "admin.users": "Usuarios",
    "admin.pushedOpps": "Oportunidades Publicadas",
    "admin.accessDenied": "Acceso Denegado",
    "admin.noPrivileges": "No tienes privilegios de administrador.",
    "admin.searchUsers": "Buscar usuarios...",
    "admin.user": "Usuario",
    "admin.status": "Estado",
    "admin.portfolio": "Portafolio",
    "admin.assetsCount": "Activos",
    "admin.lastLogin": "Último Acceso",
    "admin.actions": "Acciones",
    "admin.backToList": "Volver a la lista",
    "admin.removeAdmin": "Quitar Admin",
    "admin.makeAdmin": "Hacer Admin",
    "admin.generateReport": "Generar Informe",
    "admin.confirmAdminChange": "Confirmar Cambio de Estado",
    "admin.removeAdminMsg": "Quitar privilegios admin de {name}?",
    "admin.grantAdminMsg": "Otorgar privilegios admin a {name} ({email})?",
    "admin.newOpportunity": "Nueva Oportunidad",
    "admin.createOpp": "Crear Oportunidad",
    "admin.editOpp": "Editar Oportunidad",
    "admin.oppPushed": "Se publicará como oportunidad \"Recomendado por Cableway\"",
    "admin.deleteOpp": "Eliminar Oportunidad",
    "admin.deleteOppMsg": "Eliminar \"{name}\"? Se removerá de todos los usuarios.",
    "admin.target": "Destino",
    "admin.allUsers": "Todos los Usuarios",
    "admin.selectedUsers": "Usuarios Seleccionados",
    "admin.published": "Publicado",
    "admin.expires": "Expira",
    "admin.noPublished": "Sin oportunidades publicadas",
    "admin.pushFirst": "Publica tu primera recomendación",
    "admin.publicationDate": "Fecha de Publicación",
    "admin.expirationDate": "Fecha de Expiración",
    "admin.noUsers": "No se encontraron usuarios",
    "admin.portfolioValue": "Valor del Portafolio",

    // Settings
    "settings.title": "Ajustes",
    "settings.subtitle": "Gestiona las preferencias de tu cuenta",
    "settings.profile": "Perfil",
    "settings.profileDesc": "Tu información de cuenta",
    "settings.appearance": "Apariencia",
    "settings.appearanceDesc": "Personaliza la apariencia",
    "settings.theme": "Tema",
    "settings.themeDesc": "Cambiar entre modo claro y oscuro",
    "settings.light": "Claro",
    "settings.dark": "Oscuro",
    "settings.displayCurrency": "Moneda de Visualización",
    "settings.displayCurrencyDesc": "Elige cómo mostrar los valores monetarios",
    "settings.language": "Idioma",
    "settings.languageDesc": "Elige tu idioma de visualización preferido",
    "settings.languageConvert": "Todos los textos se mostrarán en este idioma",
    "settings.currencyLabel": "Moneda",
    "settings.currencyConvert": "Todos los valores se convertirán a esta moneda",
    "settings.security": "Seguridad",
    "settings.securityDesc": "Gestiona la seguridad de tu cuenta",
    "settings.investPrefs": "Preferencias de Inversión",
    "settings.investPrefsDesc": "Configura tu perfil de inversión y la visibilidad de oportunidades",
    "settings.riskTolerance": "Tolerancia al Riesgo",
    "settings.riskToleranceDesc": "Influye en la puntuación de ajuste al portafolio para recomendaciones",
    "settings.risk_conservative": "Conservador",
    "settings.risk_moderate": "Moderado",
    "settings.risk_aggressive": "Agresivo",
    "settings.preferredRegions": "Regiones Preferidas",
    "settings.preferredRegionsDesc": "Selecciona qué regiones bursátiles te interesan más",
    "settings.visibleChannels": "Canales de Oportunidades Visibles",
    "settings.visibleChannelsDesc": "Elige qué pestañas de oportunidades mostrar",
    "settings.googleConnected": "Conectado con Google",
    "settings.googleAuth": "Tu cuenta está autenticada de forma segura vía Google",
    "settings.signOut": "Cerrar Sesión",
    "settings.signOutDesc": "Cerrar sesión de tu cuenta en este dispositivo",
    "settings.version": "Cableway Finance v1.0.0",
    "settings.builtFor": "Llevando tu patrimonio a la cima",

    // Common
    "common.loading": "Cargando...",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.add": "Agregar",
    "common.search": "Buscar",
    "common.name": "Nombre",
    "common.type": "Tipo",
    "common.value": "Valor",
    "common.date": "Fecha",
    "common.actions": "Acciones",
    "common.previous": "Anterior",
    "common.next": "Siguiente",
    "common.page": "Página",
    "common.of": "de",
    "common.results": "resultados",
    "common.never": "Nunca",
    "common.publish": "Publicar",
    "common.update": "Actualizar",

    // Budget
    "nav.budget": "Presupuesto",
    "budget.title": "Presupuesto",
    "budget.subtitle": "Controla tus ingresos y gastos",
    "budget.refresh": "Actualizar",
    "budget.monthlyIncome": "Ingresos Mensuales",
    "budget.monthlyIncomeTooltip": "Total de ingresos recurrentes convertidos a equivalente mensual",
    "budget.monthlyExpenses": "Gastos Mensuales",
    "budget.monthlyExpensesTooltip": "Gastos recurrentes definidos por el usuario convertidos a mensual",
    "budget.creditPayments": "Pagos de Créditos",
    "budget.creditPaymentsTooltip": "Pagos mensuales de tus créditos/pasivos",
    "budget.netCashFlow": "Flujo de Caja Neto",
    "budget.netCashFlowTooltip": "Ingresos menos todos los gastos y pagos de créditos",
    "budget.perMonth": "/mes",
    "budget.sources": "fuentes",
    "budget.items": "elementos",
    "budget.credits": "créditos",
    "budget.budgetHealth": "Salud del Presupuesto",
    "budget.budgetHealthTooltip": "Basado en la tasa de ahorro: 30%+ = Excelente, 20%+ = Bueno, 10%+ = Regular, 0%+ = En Riesgo, Negativo = Crítico",
    "budget.savingsRate": "Tasa de Ahorro",
    "budget.projection6m": "Proyección 6 Meses",
    "budget.projection12m": "Proyección 12 Meses",
    "budget.projectionDesc": "Basado en el flujo de caja actual",
    "budget.cashReserves": "Reservas de Efectivo",
    "budget.runway": "Autonomía",
    "budget.months": "meses",
    "budget.incomeSources": "Fuentes de Ingresos",
    "budget.incomeSourcesDesc": "Flujos de ingresos recurrentes",
    "budget.expenses": "Gastos",
    "budget.expensesDesc": "Salidas recurrentes",
    "budget.addIncome": "Agregar Ingreso",
    "budget.addExpense": "Agregar Gasto",
    "budget.editIncome": "Editar Ingreso",
    "budget.editExpense": "Editar Gasto",
    "budget.source": "Fuente",
    "budget.expense": "Gasto",
    "budget.category": "Categoría",
    "budget.monthly": "Mensual",
    "budget.actions": "Acciones",
    "budget.edit": "Editar",
    "budget.delete": "Eliminar",
    "budget.noIncome": "Sin fuentes de ingresos todavía",
    "budget.noExpenses": "Sin gastos todavía",
    "budget.addFirst": "Agrega tu primera fuente de ingresos",
    "budget.addFirstExpense": "Agrega tu primer gasto",
    "budget.creditPaymentsBreakdown": "Desglose de Pagos de Créditos",
    "budget.creditPaymentsBreakdownDesc": "Pagos mensuales de tus pasivos",
    "budget.creditName": "Crédito",
    "budget.type": "Tipo",
    "budget.monthlyPayment": "Pago Mensual",
    "budget.incomeFormDesc": "Ingresa los detalles de esta fuente de ingresos",
    "budget.expenseFormDesc": "Ingresa los detalles de este gasto",
    "budget.name": "Nombre",
    "budget.frequency": "Frecuencia",
    "budget.amount": "Monto",
    "budget.currency": "Moneda",
    "budget.startDate": "Fecha de Inicio",
    "budget.optional": "opcional",
    "budget.cancel": "Cancelar",
    "budget.add": "Agregar",
    "budget.update": "Actualizar",
    "budget.incomeAdded": "Ingreso agregado",
    "budget.incomeUpdated": "Ingreso actualizado",
    "budget.expenseAdded": "Gasto agregado",
    "budget.expenseUpdated": "Gasto actualizado",
    "budget.saveFailed": "Error al guardar",
    "budget.deleted": "Eliminado con éxito",
    "budget.deleteFailed": "Error al eliminar",
    "budget.deleteIncome": "Eliminar Ingreso",
    "budget.deleteExpense": "Eliminar Gasto",
    "budget.fetchError": "Error al cargar los datos del presupuesto",
    "budget.predictionsChart": "Pronóstico de 12 Meses",
    "budget.predictionsChartDesc": "Ingresos proyectados vs. gastos",
    "budget.monthlyAvg": "Promedio Mensual",
    "budget.recurring": "Recurrente",
    "budget.income": "Ingresos",
    "budget.totalExpenses": "Gastos Totales",
    "budget.noDataForChart": "Agrega ingresos o gastos para ver las proyecciones",
    "budget.passiveIncome": "Ingresos Pasivos",
    "budget.passiveIncomeDesc": "Ingresos que requieren mínimo esfuerzo",
    "budget.yearly": "Anual",
    "budget.passiveRatio": "Ratio pasivo",
    "budget.ofTotalIncome": "del ingreso total",
    "budget.noPassiveIncome": "Sin ingresos pasivos todavía",
    "budget.markAsPassive": "Marca las fuentes de ingresos como pasivas al agregar",
    "budget.passiveIncomeLabel": "Este es ingreso pasivo",
    "budget.passiveIncomeHint": "ej: dividendos, alquiler, intereses - ingresos que requieren poco esfuerzo",
    "budget.passive": "Pasivo",
  },
};

export default translations;
